'use strict';
namespace Reviews {

    export class ReviewsService {

        private readonly domain :any;
        private readonly imageDim :number;
        private readonly submitUrl :string;
        private readonly url :string;

        constructor(
            private $http :ng.IHttpService,
            private $q :ng.IQService,
            private fieldGroupService :Core.FieldGroupService,
            protected imageService: any) {

            this.domain = TRPCONFIG.Domain;
            this.imageDim = TRPCONFIG.DeviceSettings.LandingImageHeight;
            this.submitUrl = '/api/bookings/reviews';
            this.url = '/api2/users/reviews/';

        }

        getPredefinedTags = () :ng.IPromise<TagLists> => {

            //do api stuff

            let lists = new TagLists();
            lists.hotel = ['Free Wifi', 'Comfy beds', 'Infinity pool', 'Clean', 'Good value', 'Wonderful staff',
                                'Good Food', 'Close to beach'];
            lists.location = ['Bars & Pubs', 'Sight-seeing', 'Walking', 'Beautiful scenery', 'Romance',
                                'Outdoor Activities'];

            return this.$q.when(lists);
        }

        getHotelInformation = (hotelId :number) :ng.IPromise<HotelInformation> => {
            return this.getHotelDetails(hotelId).then(hotel => {
                let hi = new HotelInformation();
                hi.address = hotel.Address;
                hi.id = hotel.Id;
                hi.imageUrl = this.imageService.getMainImageUrl(hotel.Id, this.imageDim, this.imageDim);
                hi.location = hotel.Location;
                hi.starRating = hotel.StarRating;
                hi.title = hotel.Title;

                return hi;
            });
        }

        getReviewDetailsUsingToken =
            (bookingId :number, token :string, userId :string) :ng.IPromise<ReviewDetails> =>  {
            return this.$http.post(
                `${this.url}user/reviewdetailstoken`
                , {
                        BookingId: bookingId,
                        VerificationToken: token,
                        UserId: userId,
                        CultureCode: this.domain.CultureCode
                        }
            ).then(
                res => this.convertReviewDetailsSuccess(res.data)
                , err => this.processReviewDetailsError(err.status)
            );
        }

        getReviewDetails = (bookingId :number) :ng.IPromise<ReviewDetails> => {
            return this.$http.post(
                `${this.url}user/reviewdetails`
                , { BookingId: bookingId, CultureCode: this.domain.CultureCode }
            ).then(res => this.convertReviewDetailsSuccess(res.data)
                , err => this.processReviewDetailsError(err.status)
            );
        }


        submitReview = (data :ReviewData, bookingId :number, token :string) :ng.IPromise<any> => {
            return this.$http.post(
                `${this.submitUrl}`
                , { Token: token, Review: this.convertUserDataToApiReview(data, bookingId)}
            );
        }

        ///Get basic details about a hotel given it's id
        private getHotelDetails = (hotelId :number) :ng.IPromise<ApiHotelDetails> => {
            return this.$http.post('/api/hotels/static/gethotelsbyid', {
                Ids: [hotelId],
                CultureCode: this.domain.CultureCode,
                DomainId: this.domain.DomainId,
                FieldFlags: this.fieldGroupService.getFieldGroup(
                    Core.FieldType.Global,
                    Core.FieldType.Titles
                )
            }, { ignoreErrors: true }).then(function(result) {
                return result.data[0];
            });
        }


        private convertReviewDetailsSuccess = (reviewDetails :ApiReviewDetailsResponse) :ReviewDetails => {

            let hotelInfo = new HotelInformation();
            hotelInfo.address = reviewDetails.Hotel.Address;
            hotelInfo.id = reviewDetails.Hotel.EstabId;
            hotelInfo.imageUrl =
                    this.imageService.getMainImageUrl(reviewDetails.Hotel.EstabId, this.imageDim, this.imageDim);
            hotelInfo.location = _.find(reviewDetails.Hotel.Destinations, (d :ApiDestination) => d.Type === 2).Title;
            hotelInfo.starRating = reviewDetails.Hotel.StarRating;
            hotelInfo.title = reviewDetails.Hotel.Title;

            let details = new ReviewDetails();
            details.checkedInDate = reviewDetails.CheckInDate;
            details.hotelDetails = hotelInfo;
            details.contactDetails = {
                county: reviewDetails.LeadContact.County,
                firstname : reviewDetails.LeadContact.FirstName,
                lastname : reviewDetails.LeadContact.LastName,
                title : reviewDetails.LeadContact.Title
            };
            details.reviewStatus = reviewDetails.ReviewStatus;

            return details;
        }


        private processReviewDetailsError = (errCode :number) :ReviewDetails => {
            //we can have a number of different states but just return the correct enum value
            let details = new ReviewDetails();
            details.reviewStatus = ReviewStatus.CannotLeaveReview;

            if (errCode === 401) {
                details.reviewStatus = ReviewStatus.CannotLeaveReview;
            }

            return details;
        }


        private convertUserDataToApiReview = (data :ReviewData, bookingId :number) :ApiReviewData => {

            let ratings = [
                {Type: RatingType.Location, Score: data.ratings.location},
                {Type: RatingType.Hotel, Score: data.ratings.room},
                {Type: RatingType.Service, Score: data.ratings.service},
            ];

            let hotelTags = _.map(data.tags.hotel, t => { return {Type: TagType.Hotel, Title: t}; });
            let locationTags = _.map(data.tags.location, t => { return {Type: TagType.Location, Title: t}; });

            return {
                Anonymous : data.anonymous,
                BookingId : bookingId,
                Title : data.title,
                Comments : data.text,
                TravellerType : TravellerType[data.travellerType],
                Ratings : ratings,
                Tags : hotelTags.concat(locationTags)
            };
        }
    }


    angular.module('reviews').service('reviewsService', ReviewsService);
}
